class LoginFormController {
  constructor(Auth) {
    this.Auth = Auth
  }

  $onInit() {
    this.credentials = { accessible_type: 'Engineer' };
  }

  handleSubmit($event) {
    this.error = null;
    $event.preventDefault();
    this.Auth.login(this.credentials)
      .then(this.onLogin)
      .catch((response) => {
        this.error = response.data.error;
      });
  }
}

LoginFormController.$inject = ['Auth'];
export default LoginFormController;



// WEBPACK FOOTER //
// ./src/app/screens/login/components/login-form/login-form.controller.js